var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRight2Svg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Solid",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.91107 15.5899C6.58563 15.2645 6.58563 14.7368 6.91107 14.4114L11.3218 10.0007L6.91107 5.58991C6.58563 5.26447 6.58563 4.73683 6.91107 4.4114C7.23651 4.08596 7.76414 4.08596 8.08958 4.4114L13.0896 9.4114C13.415 9.73683 13.415 10.2645 13.0896 10.5899L8.08958 15.5899C7.76414 15.9153 7.23651 15.9153 6.91107 15.5899Z",
    fill: "#667085"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight2Svg);
export default __webpack_public_path__ + "static/media/ArrowRight2Svg.b8bc607815e83735dcc5e876f1572c06.svg";
export { ForwardRef as ReactComponent };